type ObjectType = { [index: string]: string };

const getComponents = require.context("/", false, /[\w-].vue$/);
// console.log("getComponents.keys()", getComponents.keys());
const result = getComponents
  .keys()
  .reduce((obj: ObjectType, name: string): ObjectType => {
    const comp = getComponents(name);
    const key: string = name.replace("./", "").split(".")[0];
    obj[key] = comp.default;
    return obj;
  }, {});

export default result;
